import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from 'react';
import {useRqTaskInfo} from '../../react_query/tasks/ListTasks';
import {useParams} from 'react-router-dom';
import {ITaskItem} from '../../dto/Task.dto';

// Define the context type
interface TaskContextType {
  data: ITaskItem | null;
  isFetching: boolean;
  isFetched: boolean;
  isError: boolean;
  error: unknown;
  isPreview: boolean;
  setIsPreview: React.Dispatch<React.SetStateAction<boolean>>;
  isGT: boolean;
  isNR: boolean;
  companyId: number;
  taskId: number;
}

// Create the context
const TaskContext = createContext<TaskContextType | undefined>(undefined);

// Create a provider component
export const TaskProvider = ({children}: {children: ReactNode}) => {
  const taskParam = useParams();
  const taskId = Number(taskParam.task_id);
  const {data, isFetching, isError, error, isFetched} = useRqTaskInfo(taskId);
  const [isPreview, setIsPreview] = useState<boolean>(false);
  const [isGT, setIsGT] = useState<boolean>(false);
  const [isNR, setIsNR] = useState<boolean>(false);
  const [companyId, setCompanyId] = useState<number>(0);

  useEffect(() => {
    if (data && !isFetching && !isError) {
      if (data.company?.id) {
        setCompanyId(data.company?.id);
      }
      if (data?.company?.product) {
        if (data.company.product.cmc_product === 'GameTime' && setIsGT) {
          setIsGT(true);
        } else if (
          data.company.product.cmc_product === 'Neptune Radio' &&
          setIsNR
        ) {
          setIsNR(true);
        }
      }
    }
  }, [data, isFetching, isError]);

  return (
    <TaskContext.Provider
      value={{
        data: data ?? null,
        isFetching,
        isFetched,
        isError,
        error,
        isPreview,
        setIsPreview,
        isGT,
        companyId,
        isNR,
        taskId,
      }}>
      {children}
    </TaskContext.Provider>
  );
};

// Custom hook to use the TaskContext
export const useTaskContext = () => {
  const context = useContext(TaskContext);
  if (!context) {
    throw new Error('useTaskContext must be used within a TaskProvider');
  }
  return context;
};

export const useOptionalTaskContext = () => {
  return useContext(TaskContext);
};
